module.exports = __webpack_public_path__ + "img/poly-4.fe33ada5.png";